export default "__VITE_ASSET__DJXQf1FX__"